import REGISTER_URL from "./constants";

const openRegistrationForm = () => {
  window.open(REGISTER_URL, "_blank");
};

export default openRegistrationForm;
